import { render, staticRenderFns } from "./menuGroupCatalogManage.vue?vue&type=template&id=d0987ae8&scoped=true"
import script from "./menuGroupCatalogManage.vue?vue&type=script&lang=js"
export * from "./menuGroupCatalogManage.vue?vue&type=script&lang=js"
import style0 from "./menuGroupCatalogManage.vue?vue&type=style&index=0&id=d0987ae8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0987ae8",
  null
  
)

export default component.exports